import { Book, HTMLBlock, Sentence, copyRestObject } from "../../../../rest/models";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { AppDispatch } from "../../../../store/store";
import { Button } from "../../../RequestRespectingInputs";
import { renumberBlocksAndSentences } from "../../utils";
import { bookReaderActions } from "../slice";

export function EWRBlockEditor(props: Props)
{
    const appDispatch = useAppDispatch();
    const {block} = props;

    const state = useAppSelector(function(state)
    {
        const {book, blocksByParent, sentencesByBlock} = state.bookReader;
        return {book, blocksByParent, sentencesByBlock};
    });
    
    const type = block.type === 'p' ? 'paragraph' : 'block';
    
    return (
    <fieldset className='ernots_EWRBlockEditor'>
        <Button
            onClick={e => addBlock(state.book as Book, props.block, appDispatch)}
            children={`Add ${type}`}/>
        <Button
            onClick={e => deleteBlock(state.book as Book, props.block, state.blocksByParent, state.sentencesByBlock, appDispatch)}
            children={`Delete ${type}`}/>
    </fieldset>)
}

interface Props
{
    block: HTMLBlock;
}

type SentencesByBlock = { [parent_block_id: string]: Sentence[]; }
type BlocksByParent = {[parent_block_id: number]: HTMLBlock[]}

function addBlock(book: Book, currentBlock: HTMLBlock, appDispatch: AppDispatch)
{
    book = JSON.parse(JSON.stringify(book));
    const newBlock = copyRestObject(new HTMLBlock(), HTMLBlock);

    newBlock.type = currentBlock.type;
    newBlock.parent_block_id = currentBlock.parent_block_id;
    newBlock.position = currentBlock.position + 1e-9;
    newBlock.block_id = currentBlock.block_id + 1e-9;
    
    book.htmlblock_set.push(newBlock);
    renumberBlocksAndSentences(book);

    book.unsaved_changes = true;
    appDispatch(bookReaderActions.setBook(book));
}

function deleteBlock(book: Book, currentBlock: HTMLBlock, blocksByParent: BlocksByParent, sentencesByBlock: SentencesByBlock, appDispatch: AppDispatch)
{
    const childBlocks = blocksByParent[currentBlock.block_id];
    const sentences = sentencesByBlock[currentBlock.block_id];

    if (childBlocks?.length || sentences?.length)
    {
        window.alert('Blocks cannot be deleted if they have child blocks or sentences.');
        return;
    }

    book = JSON.parse(JSON.stringify(book));
    if (window.confirm('Delete block?'))
    {
        book.htmlblock_set.splice(currentBlock.block_id, 1);
        renumberBlocksAndSentences(book);

        book.unsaved_changes = true;
        appDispatch(bookReaderActions.setBook(book));
    }
}